<script setup>
import PlusSvg from "@/components/UI/svg/PlusSvg.vue";
import ConditionItem from "@/components/Filter/ConditionItem.vue";
import {ref, onMounted, watchEffect, defineModel, defineProps} from "vue";
import {Api} from "@/service/api";
import SelectDropdown from "@/components/UI/SelectDropdown.vue";


const conditions = defineModel('conditions')
const conditionType = defineModel("conditionType")
const spreadsheetId = defineModel("spreadsheetId")
const tabId = defineModel("tabId")


const props = defineProps({
    conditionTypes: {
        type: Array,
        required: true,
    },
    headerIndex: {
        type: Number,
        required: true,
        default: 1,
    },
    isManyTables: {
        type: Boolean,
        required: true,
    }
})


const columns = ref([])
const criteria = ref([])


const isColumnsLoading = ref(false)


watchEffect(async () => {
    if (!spreadsheetId.value || (tabId.value === null || tabId.value === undefined)) return
    isColumnsLoading.value = true
    let response = {}
    if (!props.isManyTables) {
        response = await Api.getTableColumns(spreadsheetId.value, tabId.value, props.headerIndex - 1)
    }
    else {
        response = await Api.getTableColumnsEmpty()
    }
    if (response.status === 'error') {
        isColumnsLoading.value = false
        return
    }
    isColumnsLoading.value = false
    columns.value = response.data;
})

onMounted(async () => {
    criteria.value = await Api.getFilterCriteria()
})


async function reloadColumns() {
    isColumnsLoading.value = true
    let response = {}

    if (!props.isManyTables) {
        response = await Api.getTableColumns(spreadsheetId.value, tabId.value, props.headerIndex - 1)
    }
    else {
        response = await Api.getTableColumnsEmpty()
    }
    if (response.status === 'error') {
        isColumnsLoading.value = false
        return
    }

    isColumnsLoading.value = false
    columns.value = response.data;

    for (let i = 0; i < conditions.value.length; i++) {
        conditions.value[i].column = {}
    }
}


function addCondition() {
    conditions.value.push({
        id: conditions.value.length,
        column: {},
        criteria: {},
        filter_value: {
            type: "",
            data: ""
        }
    })
}

function removeCondition(condition) {
    conditions.value.splice(conditions.value.indexOf(condition), 1);
}

</script>

<template>
    <div class="w-full flex flex-col items-center">
        <SelectDropdown
            class="w-[calc(100%-80px)]"
            v-model="conditionType"
            :values="props.conditionTypes"
            label="Тип условия"
            :format-function="(item) => `${item.name}`"
            :is-error="false"
        />
        <div class="mt-5 w-[calc(100%-80px)] border border-black rounded-md flex flex-col items-center mb-10">
            <div class="w-[calc(100%-20px)] my-4" v-for="(condition, index) in conditions" v-bind:key="condition">
                <ConditionItem
                    v-model="conditions[index]"
                    @reload-columns="reloadColumns"
                    @remove-condition="removeCondition(condition)"
                    :table-columns="columns"
                    :criteria="criteria"
                    :isLoading="isColumnsLoading"
                />
            </div>
            <div class="w-[calc(100%-40px)] flex items-center justify-center hover:bg-blue-50 my-4 rounded-md transition-all cursor-pointer duration-200" v-on:click="addCondition">
                <div class="flex items-center justify-center gap-3 py-4">
                    <div>
                        <PlusSvg class="size-6 stroke-2 stroke-blue-600"/>
                    </div>
                    <div class="font-bold text-blue-600">
                        Добавить условие
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>